/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest =
  {
    workspaceId: string;
    id: string;
  };

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus =
  {
    WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
    WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
    WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
    WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
    WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
    WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
    WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
    WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
    WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
    WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
    WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang
  >;

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay
  >;

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours =
  {
    id?: string | undefined;
    day?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay
  >;

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours =
  {
    id?: string | undefined;
    day?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange
  >;

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits
  >;

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat =
  {
    OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
    OutputFormatJson: "OUTPUT_FORMAT_JSON",
    OutputFormatCsv: "OUTPUT_FORMAT_CSV",
    OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
    OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat
  >;

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: Date | undefined;
    lastRunTime?: Date | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus
      | undefined;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    jobs?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat
      | undefined;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData =
  {
    workflow?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow
      | undefined;
  };

/**
 * Retrieves details of a specific workflow
 */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody =
  {
    data:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workspaceId: z.string(),
    id: z.string(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$Outbound =
  {
    workspaceId: string;
    id: string;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest
  > = z.object({
    workspaceId: z.string(),
    id: z.string(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequestToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRequest' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHoursToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHoursToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviewsToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeadsToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowsStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobsToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat
  > =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$inboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: string | undefined;
    lastRunTime?: string | undefined;
    status: string;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    jobs?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$Outbound
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat: string;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdStatus$outboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflowFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workflow: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$inboundSchema
    ).optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$Outbound =
  {
    workflow?:
      | GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$Outbound
      | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData
  > = z.object({
    workflow: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdWorkflow$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDataToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdDataFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$inboundSchema
    ),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$Outbound =
  {
    data:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$Outbound;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdData$outboundSchema
    ),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBodyToJSON(
  getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdResponseBody' from JSON`,
  );
}
